import dayjs from "dayjs";
import DebounceSelect from "../common/DebounceSelect";
import { Button, DatePicker, Modal, Tag } from "antd";
import { DeleteOutlined, DownloadOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import TablePage from "../components/TablePage";
import { api } from "../common/api";
import { date2locale, downloadFile } from "../common/common";

const columns = [
  { title: "Nome", key: "name", dataIndex: "name", sorter: true, width: 260, ellipsis: true },
  {
    title: "Tag",
    key: "tag",
    sorter: true,
    dataIndex: ["tag", "name"],
    width: 180,
    ellipsis: true,
    render: (tag) => <Tag variant={"outlined"}>{tag}</Tag>,
  },
  {
    title: "Data",
    key: "date",
    sorter: true,
    dataIndex: "date",
    width: 150,
    render: (date) => (date ? date2locale(date) : "-"),
  },
  {
    title: "Scadenza",
    key: "dueDate",
    sorter: true,
    dataIndex: "dueDate",
    width: 150,
    render: (date) => (date ? date2locale(date) : "-"),
  },
  {
    title: "File",
    key: "file",
    width: 100,
    render: (record) => (
      <Button
        aria-label={`Scarica ${record.name}`}
        size={"small"}
        icon={<DownloadOutlined />}
        onClick={() => downloadFile(`document/${record.id}/file`)}
      />
    ),
  },
];

const dateFilter = (name, label) => ({
  name,
  label,
  readableValue: date2locale,
  formItem: {
    props: {
      getValueProps: (value) => ({ value: value ? dayjs(value) : null }),
      normalize: (value) => value?.format("YYYY-MM-DD"),
    },
    children: <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />,
  },
});

const filterItems = [
  {
    name: "tag",
    label: "Tag",
    readableValue: (value) => value && JSON.parse(value).label,
    formItem: {
      props: {
        getValueProps: (value) => ({ value: value && JSON.parse(value) }),
        normalize: (value) => value && JSON.stringify(value),
      },
      children: (
        <DebounceSelect
          allowClear
          minSize={0}
          fetchOptions={(query) =>
            api.tag
              .list({ query, pageSize: 9999 })
              .then(({ data }) => data.map((tag) => ({ label: tag.name, value: tag.id })))
          }
        />
      ),
    },
  },
  dateFilter("startDate", "Data dal"),
  dateFilter("endDate", "Data al"),
  dateFilter("startDueDate", "Scadenza dal"),
  dateFilter("endDueDate", "Scadenza al"),
];

export default function AssetDocuments({
  ownerId,
  ownerType,
  title,
  addPath = "documents/new",
  editPath = (id) => `documents/${id}/edit`,
}) {
  const navigate = useNavigate();

  return (
    <TablePage
      title={title}
      columns={columns}
      filterItems={filterItems}
      addPath={addPath}
      addInTable
      enableSelection={false}
      fetchFunction={({
        query,
        tag,
        startDate,
        endDate,
        startDueDate,
        endDueDate,
        sortField,
        sortOrder,
        page,
        pageSize,
      }) =>
        api.document.list({
          query,
          tag: tag ? JSON.parse(tag).value : undefined,
          startDate,
          endDate,
          startDueDate,
          endDueDate,
          sortField,
          sortOrder,
          page,
          pageSize,
          type: ownerType,
          sourceId: ownerId,
        })
      }
      actionsMenu={{
        items: () => [
          { key: "edit", label: "Modifica", icon: <EditOutlined /> },
          {
            key: "remove",
            label: "Rimuovi",
            icon: <DeleteOutlined />,
            danger: true,
          },
        ],
        onClick: (key, record, refresh) => {
          if (key === "edit") navigate(editPath(record.id));
          if (key === "remove")
            Modal.confirm({
              title: `Rimuovere il documento? `,
              okText: "Rimuovi",
              cancelText: "Annulla",
              onOk: () => api.document.delete(record.id).then(refresh),
            });
        },
      }}
    />
  );
}
